import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { SearchComponent } from './search.component';

@NgModule({
    imports: [CommonModule, FormsModule, TranslateModule, PopoverModule.forRoot()],
    exports: [SearchComponent],
    declarations: [SearchComponent]
})
export class SearchModule {}
